import React, { useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ChangePasswordCard() {
  const { user } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  if (!user || user.auth_provider === "google") return null;

  const save = async () => {
    if (next.length < 8) return toast.error("New password must be at least 8 characters.");
    if (next !== confirm) return toast.error("New passwords don't match.");
    setSaving(true);
    try {
      await api.put("/settings/password", { current_password: current, new_password: next });
      setCurrent(""); setNext(""); setConfirm("");
      toast.success("Password changed successfully");
    } catch (e) { toast.error(e.response?.data?.detail || "Couldn't change your password"); }
    finally { setSaving(false); }
  };

  return (
    <Card className="rounded-3xl border-slate-100 p-6 shadow-sm" data-testid="settings-password-card">
      <div className="mb-5 flex items-start gap-3"><span className="flex h-10 w-10 items-center justify-center rounded-xl bg-slate-50"><Lock className="h-5 w-5 text-slate-500" /></span><div><h2 className="font-heading text-lg font-bold text-slate-900">Change password</h2><p className="text-sm text-slate-500">Use a new password to keep your account secure.</p></div></div>
      <div className="max-w-xl space-y-3">
        <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} placeholder="Current password" autoComplete="current-password" className="h-11 rounded-xl" data-testid="input-current-password" />
        <Input type="password" value={next} onChange={(e) => setNext(e.target.value)} placeholder="New password (8+ characters)" autoComplete="new-password" className="h-11 rounded-xl" data-testid="input-new-password" />
        <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm new password" autoComplete="new-password" className="h-11 rounded-xl" data-testid="input-confirm-password" />
        <Button onClick={save} disabled={saving || !current || !next || !confirm} className="h-11 rounded-full bg-pink-500 px-7 font-semibold text-white hover:bg-pink-600" data-testid="settings-change-password">{saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Change password"}</Button>
      </div>
    </Card>
  );
}
